<script>
import { Bar } from "vue-chartjs";
import { createNamespacedHelpers } from "vuex";
const { mapState,mapGetters,mapMutations } = createNamespacedHelpers("dashboard");
import {MONTH_LIST} from "../../utils/constants";
import * as Hammer from 'hammerjs';
export default {
  props: {
  selectedTenant: String,
  selectedYear: String,
  dashboardData: Array,
  },
  components: {
    Hammer,
  },
  name: "Barchart",
  extends: Bar,
  data() {
    return {
      datacollection: {
        labels: ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],
        datasets: [
          {
            label: "Completed Trips",
            pointBackgroundColor: "white",
            borderWidth: 0,
            pointBorderColor: "#249EBF",
            backgroundColor: "#0456d0",
            data: []
          },
          {
            label: "AutoCancelled Trips",
            pointBackgroundColor: "white",
            borderWidth: 0,
            pointBorderColor: "#249EBF",
            backgroundColor: "grey",
            data: []
          }
        ],
      },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
                max: 10,
                stepSize: 2,
                reverse: false,
                beginAtZero: true
              },
              gridLines: {
                display: false
              }
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: false
              }
            }
          ]
        },
        legend: {
          display: true,
          position: 'bottom',
        },
        responsive: true,
        maintainAspectRatio: false
      },
      tripsData: {
        completedTripsData: [],
        autoCancelledTripsData: []
      },
      tripTenants: [],
    };
  },

  methods: {
    getDataOnLoad() {
      const data = this.dashboardData.find(
        (vcl) => vcl.tenantId === this.selectedTenant
      );
      let completedTripsData = [];
      let autoCancelledTripsData = [];
      MONTH_LIST.forEach((item,index) => {
        completedTripsData.push({
          month: item,
          month_num: index+1,
        });
        autoCancelledTripsData.push({
          month: item,
          month_num: index+1,
        });
      });
      if(data && data.trips && data.trips.length>0) {
        data.trips.forEach(item => {
          completedTripsData.forEach(data => {
            if(item.month == data.month_num) {
              data.completed_count = item.totalCompletedTrips;
            }
          });
          autoCancelledTripsData.forEach(data => {
            if(item.month == data.month_num) {
              data.auto_cancelled_count = item.totalAutoCancelledTrips;
            }
          });
        });
      } else {
        completedTripsData.forEach(item => {
        item.completed_count = 0;
        });
        autoCancelledTripsData.forEach(item => {
        item.auto_cancelled_count = 0;
        });
      }
      let completedTripsArray = completedTripsData.map(item =>item.completed_count);
      let autocancelledTripsArray = autoCancelledTripsData.map(item =>item.auto_cancelled_count);
      this.tripsData = {
        completedTripsData: completedTripsArray,
        autoCancelledTripsData: autocancelledTripsArray
      }
      this.datacollection.datasets[0].data = this.tripsData.completedTripsData;
      this.datacollection.datasets[1].data = this.tripsData.autoCancelledTripsData;
      this.renderChart(this.datacollection, this.options);
    }
  },
  computed:{
    ...mapState(["noOfTrips"]),
    ...mapGetters(["getTenantsByTrips"]),
    ...mapMutations(["getNoOfTrips"]),
  },
  watch: {
    selectedTenant(val) {
      this.getDataOnLoad();
      return val;
    },
    selectedYear(val) {
      this.getDataOnLoad();
      return val;
    },
    dashboardData(val) {
      this.getDataOnLoad();
      return val;
    },
  },
  mounted() {
    this.getDataOnLoad();
  },
};
</script>